const storageKey = 'oislohe-cart-countdown-deadline-v1';
const duration = 10 * 60 * 1000;
let memoryDeadline;
class OisloheCartCountdown extends HTMLElement {
  connectedCallback() {
    if (this.timer) return;
    let saved = memoryDeadline;
    try {
      const value = Number(sessionStorage.getItem(storageKey));
      if (Number.isFinite(value) && value > 0) saved = value;
    } catch {}
    this.deadline = saved || Date.now() + duration;
    memoryDeadline = this.deadline;
    try { sessionStorage.setItem(storageKey, String(this.deadline)); } catch {}
    this.setAttribute('role', 'timer');
    this.tick();
    if (this.deadline > Date.now()) this.timer = setInterval(() => this.tick(), 1000);
  }
  tick() {
    const remaining = Math.max(0, Math.min(600, Math.ceil((this.deadline - Date.now()) / 1000)));
    const text = String(Math.floor(remaining / 60)).padStart(2, '0') + ':' + String(remaining % 60).padStart(2, '0');
    const display = this.querySelector('span');
    if (display) display.textContent = text;
    this.setAttribute('aria-label', text);
    if (remaining === 0) {
      clearInterval(this.timer);
      this.timer = undefined;
    }
  }
  disconnectedCallback() {
    clearInterval(this.timer);
    this.timer = undefined;
  }
}
if (!customElements.get('oislohe-cart-countdown')) {
  customElements.define('oislohe-cart-countdown', OisloheCartCountdown);
}
